import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'
import {
  setCCDurationUnitsOptions,
  setOCDurationUnitsOptions,
  setSCDurationUnitsOptions,
} from '../store/options.actions'

export function* getDurationUnitsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const ccDurationUnitsOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getCCDurationUnitsOptions,
    ])
    yield put(setCCDurationUnitsOptions(ccDurationUnitsOptionsResponse.entity || []))

    const scDurationUnitsOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getSCDurationUnitsOptions,
    ])
    yield put(setSCDurationUnitsOptions(scDurationUnitsOptionsResponse.entity || []))

    const ocDurationUnitsOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getOCDurationUnitsOptions,
    ])
    yield put(setOCDurationUnitsOptions(ocDurationUnitsOptionsResponse.entity || []))
  } catch (e) {
    yield put(throwPcrException(`getDurationUnitsOptions() error: ${e}`))
  }
}

export function* getDurationUnitsOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getDurationUnitsOptions)
}
